import BasicSignUpForm from './BasicSignUpForm'
import { prop } from 'ramda'
import { connect } from 'react-redux'

const mapStateToProps = ({ authentication }) => ({
  consent: prop('consent', authentication),
})

export default connect(mapStateToProps)(BasicSignUpForm)
